import {Injectable, NgZone} from '@angular/core';
import {StatusBar} from '@capacitor/status-bar';
import {HttpClient} from '@angular/common/http';
import {SessionService} from './session.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../app/app.state';
import {NativeMobileService} from './native-mobile.service';
import {AlarmsService} from './alarms.service';
import {UrlService} from './url.service';
import {Keyboard, KeyboardStyle} from '@capacitor/keyboard';

@Injectable({
  providedIn: 'root',
})
export class NativeIosService extends NativeMobileService {
  constructor(
    protected http: HttpClient,
    protected session: SessionService,
    protected store: Store<AppState>,
    protected alarmsService: AlarmsService,
    protected urlService: UrlService,
    protected ngZone: NgZone,
  ) {
    super(http, session, store, alarmsService, urlService, ngZone);

    Keyboard.setStyle({
      style: KeyboardStyle.Dark,
    });
  }


  afterDeviceInfoLoaded() {
    if (this.deviceInfo.model.toUpperCase().indexOf('IPAD') > -1) {
      StatusBar.hide();
    } else {
      StatusBar.show();
    }
  }
}
